import React from 'react';
import { IconButton as ChButton, forwardRef } from "@chakra-ui/react";

import Link from './Link'

const IconButton = forwardRef(({ href, trackerName, onClick, ...props }, ref) => {
  const handleTrackEvent = (e) => {
    if (onClick) {
      onClick(e)
    }
    if (trackerName && typeof window.gtag === 'function') {
      window.gtag("event", "click_button", {
        button_name: trackerName,
      });
    }
  }
  if (href && !props.isDisabled) return <ChButton ref={ref} href={href} as={Link} onClick={handleTrackEvent} {...props} />
  return <ChButton onClick={handleTrackEvent} {...props} ref={ref} />
})

export default IconButton
